import {useCallback, useState} from "react";

const useHttp = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();

    const sendRequest = useCallback(async (requestConfig, responseCallback, errorCallback) => {
        setIsLoading(true);
        setError(undefined);
        try {
            console.log(`REQUEST : ${JSON.stringify(requestConfig.body)}`)
            const token = localStorage.getItem('ibill_access_token');
            const headers= requestConfig.headers ? requestConfig.headers : {}
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            // Note: companyId header will be injected by the API Gateway
            const response = await fetch(
                requestConfig.url, {
                    method: requestConfig.method ? requestConfig.method : 'GET',
                    headers,
                    body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
                }
            );
            const jsonResp = await response.json();
            //console.log(`${JSON.stringify(jsonResp)}`)
            if (!response.ok) {
                throw Error(`Request failed. Please try again later.`);
            } else if (jsonResp.status === 'OK' || jsonResp.status?.code === 200) {
                // Standard wrapped response format
                responseCallback(jsonResp.data);
            } else if (Array.isArray(jsonResp)) {
                // Direct array response (e.g., GET /api/mapping/server/{code}/vlans)
                responseCallback(jsonResp);
            } else if (Array.isArray(jsonResp.content) && jsonResp.totalElements !== undefined) {
                // PageResponse format { content: [...], totalElements, page, size, totalPages }
                responseCallback(jsonResp);
            } else if (jsonResp.message || jsonResp.portId || jsonResp.vlanId || jsonResp.serverCode || jsonResp.blockId || jsonResp.totalMappingsCreated !== undefined) {
                // Direct object response (mapping and IP block endpoints)
                responseCallback(jsonResp);
            } else {
                if(jsonResp.data?.errorMessage) {
                    throw Error(jsonResp.data.errorMessage);
                }
                else if(response.status !== 'OK' && typeof jsonResp.data === "string") {
                    throw Error(jsonResp.data);
                }
                throw Error(`Operation failed. Please check your input and try again.`);
            }
        } catch (err) {
            // Sanitize technical error messages for user display
            let errorMessage = err.message || 'An unexpected error occurred';

            // Replace technical errors with user-friendly messages
            if (errorMessage.includes('Cannot read properties')) {
                errorMessage = 'Unable to process server response. Please try again.';
            } else if (errorMessage.includes('Network request failed') || errorMessage.includes('Failed to fetch')) {
                errorMessage = 'Network error. Please check your connection and try again.';
            } else if (errorMessage.includes('JSON')) {
                errorMessage = 'Invalid server response. Please contact support.';
            }

            setError(errorMessage);
            if (errorCallback) {
                errorCallback({ message: errorMessage });
            }
        }
        setIsLoading(false);
    }, []);
    // Note: companyId header will be injected by the API Gateway
    const uploadFile = useCallback(async (requestConfig, responseCallback, errorCallback) => {
        setIsLoading(true);
        setError(undefined);
        try {
            const token = localStorage.getItem('ibill_access_token');
            const headers= requestConfig.headers ? requestConfig.headers : {}
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            // Note: companyId header will be injected by the API Gateway
            const formData = new FormData();
            formData.append('file', requestConfig.file);
            const response = await fetch(
                requestConfig.url, {
                    method: 'POST',
                    headers,
                    body: formData,
                }
            );
            const jsonResp = await response.json();
            console.log(`${JSON.stringify(jsonResp)}`)
            if (!response.ok) {
                throw Error(`File upload failed. Please try again.`);
            } else if (jsonResp.status === 'OK' || jsonResp.status?.code === 200) {
                responseCallback(jsonResp.data);
            } else {
                errorCallback(jsonResp.data);
            }
        } catch (err) {
            let errorMessage = err.message || 'Something went wrong!';

            // Sanitize technical errors
            if (errorMessage.includes('Cannot read properties')) {
                errorMessage = 'Unable to process upload response. Please try again.';
            } else if (errorMessage.includes('Network request failed') || errorMessage.includes('Failed to fetch')) {
                errorMessage = 'Network error. Please check your connection.';
            }

            setError(errorMessage);
        }
        setIsLoading(false);
    }, []);

    return {
        isLoading,
        error,
        sendRequest,
        uploadFile
    };
}

export default useHttp;